import React from 'react';

const Skeleton = ({ className }) => (
  <div className={`animate-pulse bg-luma-sand/30 rounded-lg ${className}`}></div>
);

export const ProductSkeleton = () => (
  <div className="space-y-4">
    <Skeleton className="aspect-[3/4] rounded-3xl" />
    <div className="flex justify-between items-start">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-3 w-12" />
    </div>
    <Skeleton className="h-6 w-3/4" />
    <Skeleton className="h-4 w-1/2" />
  </div>
);

export default Skeleton;